import "../stylesheets/App.css";
import "../stylesheets/ForgotPassword.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./subcomponents/Loader.js";
import PopupMailEnviado from "./subcomponents/PopupMailEnviado.js";

function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [openPopup, setOpenPopup] = useState(false);


  const navigate = useNavigate();

  // fondo exclusivo de login
  useEffect(() => {
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  const forgotPassword = async () => {
    setLoading(true);
    setErrorMsg("");

    const item = { email };

    try {
      // 1) Validar que el email exista / sea válido (según tu back)
      let result = await fetch(
        process.env.REACT_APP_API_BASE_URL + "/users/forgotPassword",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );

      const json1 = await result.json();

      if (json1.status !== 200) {
        setErrorMsg(json1?.data?.errors?.[0]?.msg || "Error al validar el email");
        setLoading(false); // ✅ antes faltaba
        return;
      }

      // 2) Enviar mail con contraseña temporal
      result = await fetch(
        process.env.REACT_APP_API_BASE_URL + "/users/sendMailForgot",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );

      const json2 = await result.json(); // ✅ ahora sí evaluás el status del JSON

      setLoading(false);

      if (json2.status === 200) {
        setOpenPopup(true);
      } else {
        setErrorMsg(json2?.data?.errors?.[0]?.msg || "No se pudo enviar el correo");
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
      setErrorMsg("Ocurrió un error. Intenta de nuevo.");
    }
  };

  return (
    <>
      <img
        className="forgot-password-img"
        src={process.env.PUBLIC_URL + "/images/login/Logo-Login-HMQ-2.png"}
        alt=""
      />

      <div className="forgot-password-container section-70">
        <h1 className="forgot-password-title">Recuperar contraseña</h1>

        <input
          className="inp"
          type="text"
          placeholder="Correo electrónico"
          id="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <span className="error-msg">{errorMsg}</span>

        <div className="login-btn-container">
          <button
            type="submit"
            className="btn red-btn margin-bottom-10"
            onClick={forgotPassword}
            disabled={loading}
          >
            Recuperar contraseña
          </button>

          <button className="btn blue-btn" onClick={() => navigate("/login")}>
            Cancelar
          </button>
        </div>
        <img className="login-bottom-img" src={process.env.PUBLIC_URL + "/images/login/login-bottom-img.png"}/>
      </div>

      {loading ? <Loader /> : ""}

      {openPopup ? (
        <PopupMailEnviado
          title="Correo enviado con éxito"
          description="Revisa tu bandeja de entrada para acceder con la contraseña temporal que te enviamos. ¡No olvides revisar el spam!"
          setOpenPopup={setOpenPopup}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default ForgotPassword;
